"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.isempty")),
    _uiKit = require("@devsta/ui-kit"),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    TeamCredits = function TeamCredits(a) {
  var b = a.teamCreditInfo,
      c = a.creditType,
      d = a.onSelectTeam,
      e = (0, _memoizeOne["default"])(function () {
    return b.map(function (a) {
      var b = a.team;
      return {
        label: b.name,
        value: b.teamId,
        suffix: b.creditBalance && "TEAM" === c ? _react["default"].createElement("b", null, "".concat(b.creditBalance.balance + b.creditBalance.rolloverBalance, " Credits")) : null
      };
    });
  }),
      f = e(),
      g = (0, _react.useState)(f[0]),
      h = (0, _slicedToArray2["default"])(g, 2),
      i = h[0],
      j = h[1],
      k = "TEAM" === c ? "WHICH TEAM IS THIS PAYMENT UNDER?" : "WHICH TEAM IS THIS VIDEO UNDER?";
  return _react["default"].createElement(_react["default"].Fragment, null, !(0, _lodash["default"])(f) && _react["default"].createElement(_uiKit.Dropdown, {
    options: f,
    onChange: function onChange(a) {
      j(a), d(a);
    },
    defaultValue: i || f[0],
    label: k,
    fontSize: 12,
    showSelectedSuffix: "TEAM" === c,
    disabled: 1 === b.length
  }));
},
    _default = TeamCredits;

exports["default"] = _default;